// This is just an example,
// so you can safely delete all default props below

export default {
  download: {
    preparing_files: 'Preparing Files',
    please_wait: 'Please wait...',
    collecting_documents: 'Collecting documents for application',
    error_message: 'We could not generate the file.',
    try_again: 'Try Again',
    download_started: 'Download started!',
    browser_settings_hint:
      'If the download did not start automatically, please check your browser settings.',
    fail_notify: 'Zip download failed.',
  },
  application_messages: {
    title: 'Contact Secretariat',
    no_messages: 'There are no messages yet.',
    you: 'You',
    secretary: 'Secretary',
    placeholder: 'Write your message...',
    send: 'Send',
  },
  documents: {
    type_certification: 'Select Certification',
    type_language: 'Select Language Qualification',
    type_degree: 'Select Academic Degree',
    type_work_experience: 'Select Work Experience',
    type_cv: 'Select Curriculum Vitae (CV)',
    type_document: 'Select document',
    upload_action: 'Upload File',
    profile_action: 'Select from Profile',
    archived: 'Archived',
    view_doc: 'View Document',
    no_docs: 'No documents found.',
    notes_from_secretary: 'Secretary Note',
    required: 'Required',
    optional: 'Optional',
    no_records_found: 'No records found',
    uploaded_file: 'Uploaded File',
    delete: 'Delete',
    cancel: 'Cancel',
    files_count: 'Files',
    max_files: 'Max Files',
    submit_upload: 'Upload files',
    upload_replacement: 'Upload replacement file',
    replacement_requested: 'File replacement requested',
    missing_file: 'Missing',
    delete_file_title: 'Delete file',
    delete_file_body: 'Are you sure you want to delete this file?',
    hints: {
      multiple_files: 'You can select multiple files.',
      single_file_profile: '* Selecting from profile imports 1 file per entry.',
    },
    notifications: {
      upload_remove: 'File deleted successfully!',
      upload_success: 'File uploaded successfully!',
      upload_error: 'Something went wrong during upload!',
      profile_file_not_found: 'File not found for this profile entry.',
      profile_import_success: 'Document imported from profile successfully.',
      file_size_exceeded: 'File "{name}" exceeds the {size} limit.',
      file_type_invalid: 'File type for "{name}" is not supported.',
      upload_cancelled_size: 'Upload cancelled. One or more files exceed {size}.',
      delete_error: 'Failed to delete the file.',
    },
  },
  secretary_document_manager: {
    title: 'Actions Required by Secretariat',
    subtitle:
      'The Secretariat has reviewed your application and requests the posting of the following supplementary documents.',
    secretary_notes: 'Secretary Message/Note',
    status_pending: 'Pending',
    status_fulfilled: 'Posted',
    reupload_pdf: 'Upload New File (Replace)',
  },
  navbar: {
    menu: {
      agents: 'Agents',
      login: 'login',
      login_agent: 'Agent',
      login_evaluator: 'Evaluator',
      login_secretary: 'Secretary',
      login_applicant: 'Student',
      logout: 'logout',
      profile: 'Profile',
      applications: 'Applications',
      applicants: 'Applicants',
      account: 'Account',
      fav_progs: 'Favorite programs',
      edit_profile: 'Manage profile',
      edit_applications: 'Manage your applications',
      programmes: 'Programs',
      calls: 'Calls',
      navigation: 'Navigation',
    },
    home: 'Home',
    programs: 'Programs',
    institutions: 'Institutions',
    search: 'Search programs',
    search_hint: 'Press Enter to Search',
    no_results_found: 'No results found',
  },
  pagination: {
    limit: 'Per page',
  },
  home: {
    hero_section: {
      title: 'Welcome to',
      subtitle: 'University applications made simple',
      paragraph:
        'AtSiG (Apply to Study in Greece) is a platform dedicated to streamlining applications for students to study programs in Greece and application management for Greek universities.',
      btn1_label: 'Our programs',
      btn2_label: ' Our institutions',
    },
    directions_section: {
      title: 'Academic applications made simple!',
      subtitle:
        'From creating your profile to submitting your application — everything you need in one platform.',
      col1_header: 'Create your profile',
      col1_par:
        'Create your unique profile, including your contact information, educational background and academic achievements, language certifications, and more!',
      col2_header: 'Search Programs',
      col2_par:
        'Browse and compare all the programs provided by Greek universities! Use the filters to find the perfect one for you and mark programs as favourite to receive notifications when applications are open.',
      col3_header: 'Apply, just like that',
      col3_par:
        'One click, one application. If you have all the information and documents uploaded to your profile, your academic journey is one click away!',
    },
    institutions_section: {
      title: 'Higher Education Institutions',
      subtitle: 'All Greek institutions at your fingertips.',
      btn_label: 'See all institutions',
    },
    how_to_section: {
      title: "Learn how to make the most of {'@'}SiG",
      subtitle: 'New Here?',
      btn_label: 'View Guide',
    },
    programmes_section: {
      title: 'Discover Programs',
      subtitle: "Recruiting Now through {'@'}SiG",
      btn_label: 'See All Programs',
    },
    search_prog_type: 'Program type',
    search_prog_name: 'Program name',
    search_uni: 'Select Institution',
    search_city: 'City',
    search_btn: 'Search',
  },
  footer: {
    home: 'Home',
    about: 'About',
    how_to: 'How To',
    privacy_policy: 'Privacy policy',
    terms_and_conditions: 'Terms and conditions',
    footer_subtitle: 'The all in one place for applications and programs',
  },
  institutions: {
    title: 'Search Institutions',
    subtitle: ' Find the Institution you want to apply!',
    search_description: 'Search results for "{term}" in Greek Universities. Page {page}.',
    search_btn: 'Search',
    institution_name: 'Institution name',
    visit_btn: 'Website',
    not_found: 'No Institutions found!',
    open_btn: 'Programs',
  },
  institution_details: {
    programs: 'Programs',
    programs_not_found: 'Programs not found!',
    visit_btn: 'Website',
    open_btn: 'Open',
    breadcrumb: {
      home: 'Home',
      universities: 'Institutions',
    },
  },
  programs: {
    meta_description:
      'Explore all available undergraduate and postgraduate study programs from top universities. Filter by field of study, city, and tuition fees.',
    filtered_description:
      'Found {count} study programs for {type}. View detailed information about admission requirements, tuition fees, and applications on the AtSiG platform.',
    programs_not_found: 'Programs not found!',
    title: 'Search and Apply',
    subtitle: 'Find your dream program in Greece!',
    program_title: 'Program Title',
    search_btn: 'Search',
    view_btn: 'View',
    open_call: 'Open for Application',
    apply_status: "Apply via {'@'}SiG",
    program_type: 'Program Type',
    language: 'Language',
    study_field: 'Area of Study',
    study_mode: 'Study Mode',
    tuition: 'Tuition Fees',
    institution: 'Institution',
    city: 'City',
    clear_filters: 'Clear Filters',
    fees_yes: 'fees: Yes',
    fees_no: 'fees: No',
    open_yes: 'Open for application: Yes',
    open_no: 'Open for application: No',
    apply_status_yes: "Apply via {'@'}SiG: Yes",
    apply_status_no: "Apply via {'@'}SiG: No",
    filters: 'Search Filters',
    filters_not_found: 'No filters selected!',
    lang_label: 'English',
    add_fav: 'Add to favorite',
    remove_fav: 'Remove from favorite',
    collaborating: 'Collaborating',
  },
  call_details: {
    breadcrumb: {
      home: 'Home',
      programs: 'Programs',
    },
    disciplines: {
      title: 'Available Flows',
    },
    title: 'Title',
    programme: 'Program',
    publish_date: 'Publish date',
    start_date: 'Start date',
    end_date: 'End date',
    deadline: 'Deadline',
    type: 'Type',
    academic_year: 'Academic year',
    admissions: 'Number Of Admissions',
    apply: 'Apply',
    call_file: 'Call file',
    description: 'Description',
    visit_call: 'View on Program Site',
    language_mismatch_warning:
      'Note: this call is intended for applicants of the following language(s): {languages}. Make sure this programme is the right fit before applying.',
    documents: {
      title: 'Required Documents',
      required: 'Required',
      optional: 'Optional',
      max_files: 'Max Files',
    },
  },
  program_details: {
    name: 'Program Name',
    visit_btn: 'Website',
    lead_btn: 'Express Interest',
    contact_info: 'Contact Information',
    organization: 'Organization',
    university: 'Institution',
    department: 'Department',
    school: 'School',
    flows: 'Flows',
    flows_desc: ' This program offers the following areas of specialization:',
    flows_not_found: 'No flows found!',
    languages: 'Language(s) of Instruction',
    gr_collaborating_institutes: 'Greek collaborating institutions',
    en_collaborating_institutes: 'Foreign collaborating institutions',
    eng_option: 'Taught in English',
    topics: 'Subject Area',
    study_modes: 'Mode of Delivery',
    tuition_fees: 'Tuition Fees',
    tuition_fees_tooltip:
      'These specific fees do not apply globally and might vary depending on student services offered by our partnering providers in different countries, such as India, Indonesia, Nepal, Kazakhstan, Uzbekistan.',
    duration_days: 'Days',
    semesters: 'Duration',
    semesters_tag: 'Semesters',
    is_part_time: 'Part Time Option',
    part_time_semesters: 'Part Time Duration',
    master_type: "Master's Level",
    bachelor_type: "Bachelor's Level",
    scholarship_offered: 'Scholarship Offered',
    featured_tooltip: 'Featured Program',
    yes: 'Yes',
    no: 'No',
    ects: 'ECTS Credits',
    type: 'Type',
    city: 'City',
    email: 'Email',
    phone: 'Phone',
    calls: ' Application Period ',
    apply: 'Apply',
    view_call: 'View',
    click_apply: 'Click to apply',
    click_apply_future: "Applications will be activated on the Application's Call start date",
    admission_info:
      'For foreign students, the application is made through the Hellenic Ministry of Education. To learn more about admission, check here: {link}. Admission to Greek-taught Bachelor’s programs is possible only via Panhellenic exams for Greek applicants.',
    future_application_call: 'Future application call',
    calls_not_found: 'No Open Calls found at the moment!',
    notify_me_description:
      'Register your interest today and be the first to know when new positions become available.',
    notify_me_btn: 'Notify Me!',
    breadcrumb: {
      home: 'Home',
      programs: 'Programs',
    },
  },
  login_modal: {
    login_title: 'Login',
    login_subtitle: 'Login with your account',
    login_btn: 'Login',
    new_user: 'New user?',
    register_btn: 'Register',
    or: 'OR',
  },
  favorite_programmes: {
    title: 'Favorite programs',
    open: 'Open in new tab',
    remove: 'Remove from favorite',
    programs_not_found: 'No Programs found!',
  },
  applications: {
    filter_type: 'Application Type',
    search_placeholder: 'Search',
    draft: 'Draft',
    finalized: 'Finalized',
    submitted_at: 'Submitted at',
    created_at: 'Created at',
    call: 'Call',
    program: 'Program',
    status: 'Status',
    applicant_status: 'Candidate status',
    actions: 'Actions',
    applications: 'Applications',
    applicant: 'Applicant',
    master: 'Master',
    bachelor: 'Bachelor',
    short_term: 'Short term programs',
    master_applications: 'Applications for masters',
    bachelor_applications: 'Applications for bachelors',
    short_term_applications: 'Applications for short term programs',
    new_btn: 'New Application',
    open_btn: 'Open',
    delete: 'Delete',
    edit: 'Edit',
    applications_not_found: 'No applications found!',
    breadcrumb: {
      home: 'Home',
      profile: 'Profile',
    },
    delete_title: 'Application delete',
    delete_body: 'Are you sure you want to delete this application?',
    deleted_message: 'Application deleted successfully!',
  },
  application_details: {
    not_finalized_title: 'Application not yet submitted',
    not_finalized_desc:
      'To view the details of this application, you must first finalize and submit it.',
    continue_edit_btn: 'Continue Editing',
    info_title: 'Application Details',
    evaluation_title: 'Evaluation',
    accept_modal_btn: 'Accept',
    reject_modal_btn: 'Reject',
    cancel_modal_btn: 'Cancel',
    accept_modal_title: 'Accept application',
    reject_modal_title: 'Reject application',
    accept_modal_body: 'Are you sure you want to accept this application?',
    reject_modal_body: 'Are you sure you want to reject this application?',
    application_rejected: 'You have rejected this application!',
    attendance_mode: 'Attendance Mode',
    full_time: 'Full-Time',
    part_time: 'Part-Time',
    extra_fields_title: 'Additional Information',
    yes: 'Yes',
    no: 'No',
    docs: {
      rejected_banner_title: 'Document Replacement Required!',
      rejected_banner_text:
        'One or more of your documents have been rejected. Please review the reasons and upload new files.',
      go_to_documents: 'Go to Documents',
      upload_new: 'Upload Additional Document',
      pending_title: 'Required Actions',
      pending_subtitle:
        'The secretariat has requested the following additional documents for the evaluation of your application.',
      call_docs: 'Original Application Documents',
      sec_docs: 'Supplementary Documents Requested',
      voluntary_docs: 'Documents Uploaded Directly by Applicant',
      no_voluntary_docs: 'You have not uploaded any extra document',
    },
    program: {
      program_details: 'Program Details',
      flows: 'Flows',
      flows_not_found: 'No flows found!',
      languages: 'Languages',
      topics: 'Areas of study',
      type: 'Program type',
      name: 'Program name',
      city: 'City',
      email: 'Email',
      phone: 'Phone',
      study_modes: 'Study Modes',
      call_deadline: 'Call Deadline',
    },
    status: 'Status',
    submitted_at: 'Submitted At',
    application_for: 'Application for',
    protocol: 'Protocol Number',
    call: 'Call',
    agent_id: 'Agent ID',
    applicant_comments: 'Applicant Comments',
    secretary_comments: 'Secretary Comments',
    secretary_file: 'Secretary File',
    selected_flows: 'Selected Flows',
    references: 'Invitations for references',
    info_choices: 'How did you hear about this program',
    file_btn: 'Application file',
    file_banner: 'The secretary has uploaded a file regarding your application!',
    view_btn: 'View',
    accept_btn: 'Accept',
    reject_btn: 'Reject',
    priority: 'Priority',
    add_btn: 'Add',
    accepted_flow: 'Accepted',
    references_not_found: 'No invitations for references found!',
    ref_from: 'Reference from',
    accepted_discipline: 'Accepted flow',
    accept_banner:
      'The application has been accepted by the secretary. Now you can accept it too, so the secretary can finalize the evaluation proccess!',
    breadcrumb: {
      home: 'Home',
      profile: 'Profile',
      applications: 'Applications',
      details: 'Application details',
      update: 'Application update',
    },
    references_created_message: 'Reference created successfully!',
  },
  application_form: {
    step_1: 'Application Details',
    step_2: 'Supporting Documents',
    page_title: 'New Application',
    choose_flows_msg: 'You have to choose the flows for the selected Master!',
    draft_created_message: 'Application saved. Please proceed to upload documents.',
    created_message: 'Application created successfully!',
    updated_message: 'Application updated successfully.',
    finalized_message: 'Your application has been finalized and submitted!',
    saved_later_message: 'Application saved. You can complete it later.',
    missing_requirements_error:
      'Missing required documents or profile information. Please check the highlighted fields.',
    program_details: 'Program Details',
    call_details: 'Call Details',
    view_full_call: 'View Full Call Details',
    apply_to: 'Apply to',
    profile_banner:
      'Before finalizing your application, please make sure that you have uploaded all the required documents to your profile, such as academic qualifications, work experience, etc. To submit an application, you must have at least one of your contact details added to your profile. Additionally, if you are applying for a postgraduate program, you are required to have uploaded your undergraduate degree to your profile.',
    update_profile_btn: 'Update profile',
    profile_check: 'Profile Check',
    info_choices: 'Informed for this program by',
    multiple_choice: 'Multiple choice',
    comments: 'Comments',
    agent_id: 'Agent ID',
    agent_id_hint: 'Optional (Fill it only if you are the agent)',
    comments_hint: 'Add some comments if you wish!',
    select_flows: 'Select flows',
    choose_flows: 'Choose flows',
    change_priorities: 'Change priorities',
    save_btn: 'Save',
    finalize_btn: 'Finalize',
    save_and_continue: 'Save & Continue',
    save_and_exit_btn: 'Save & Exit',
    priority: 'Priority',
    drag: 'Drag and drop to change priorities',
    entries: 'Entries',
    attendance_mode: 'Preferred Attendance Mode',
    attendance_mode_required: 'Attendance mode selection is required',
    profile: {
      contact_infos: 'Contact information',
      education_degrees: 'Education degrees',
      language_degrees: 'Language certifications',
      work_experiences: 'Work experience',
      certifications: 'Certifications',
      other_documents: 'Other Documents',
      registered: 'Registered',
      bachelor: 'Bachelor degree',
    },
    breadcrumb: {
      home: 'Home',
      programs: 'Programs',
      apply: 'Apply',
    },
    reference_modal: {
      header: 'Invite professors to upload references to your application',
      input_label: 'Professor Emails',
      input_hint: 'Multiple input, press enter after you type an email!',
      submit_btn: 'Send invites',
      cancel_btn: 'Cancel',
      rule: 'Please type an email, press enter after you type an email!',
    },
    extra_fields_title: 'Additional Information',
    missing_extra_fields_msg: 'Please fill in all required fields.',
    field_required: 'This field is required',
    rule_min_length: 'At least {n} characters',
    rule_max_length: 'At most {n} characters',
    rule_greek_only: 'Greek letters only',
    rule_latin_only: 'Latin letters only',
    rule_digits: 'Digits only',
    rule_invalid_format: 'Invalid format',
    contact_info_error: 'At least one contact method is required.',
    education_degree_error: 'The addition of at least one degree is required (BSc).',
    not_eligible_message: 'You are not eligible to apply to this call based on your nationality.',
  },
  profile: {
    save_success: 'Information saved successfully!',
    update_success: 'Information updated successfully!',
    deleted_success: 'The entry has been deleted.',
    save_error: 'An error occurred while saving. Please try again.',
    delete_error: 'Could not delete the entry. Please try again.',
    cv: 'CV',
    modal_delete_btn: 'Delete',
    modal_cancel_btn: 'Cancel',
    change_photo: 'Change Photo',
    email: 'Email',
    mobile_phone: 'Mobile phone',
    date_of_birth: 'Date of birth',
    place_of_birth: 'Place of birth',
    gender: 'Gender',
    nationality: 'Nationality',
    passport: 'Passport',
    update_profile_btn: 'Update profile',
    update_account_btn: 'Update account',
    view_cv_btn: 'View CV',
    add_btn: 'Add',
    edit_btn: 'Edit',
    delete_btn: 'Delete',
    search: 'Search',
    download: 'Download',
    whatsapp_available: 'Available on WhatsApp',
    viber_available: 'Available on Viber',
    layout: {
      profile: 'Profile',
      contact_infos: 'Contact information',
      education_degrees: 'Education degrees',
      language_certs: 'Language certifications',
      certifications: 'Certifications',
      work_experiences: 'Work experience',
      other_documents: 'Other documents',
      documents: 'Documents',
      applications: 'Applications',
    },
    contact_infos: {
      table_title: 'Contact information',
      not_found: 'No contact information found!',
      columns: {
        country: 'Country',
        city: 'City',
        address: 'Address',
        postal_code: 'Postal code',
        phone: 'Phone',
        type: 'Type',
      },
      delete_title: 'Delete contact information',
      delete_body: 'Are you sure you want to delete this contact information?',
      deleted_message: 'Contact information deleted!',
    },
    education_degrees: {
      table_title: 'Education degrees',
      not_found: 'No education degrees found!',
      columns: {
        title: 'Title',
        type: 'Type',
        country: 'Country',
        grade: 'Grade',
        institution: 'Institution / School',
        department: 'Department / Direction',
        enrollment_date: 'Duration',
      },
      delete_title: 'Delete education degree',
      delete_body: 'Are you sure you want to delete this education degree?',
      deleted_message: 'Education degree deleted!',
    },
    language_certs: {
      table_title: 'Language certifications',
      not_found: 'No language certifications found!',
      columns: {
        title: 'Title',
        language: 'Language',
        acquisition_date: 'Acquisition Date',
        score: 'Score',
      },
      delete_title: 'Delete language certification',
      delete_body: 'Are you sure you want to delete this language certification?',
      deleted_message: 'Language certification deleted!',
    },
    certifications: {
      table_title: 'Certifications',
      not_found: 'No certifications found!',
      columns: {
        name: 'Name',
        organization: 'Organization',
        issue_date: 'Issue date',
        is_expiring: 'Is expiring',
        credential_id: 'Credential id',
        credential_url: 'Credential_url',
      },
      not_given: 'Not given',
      delete_title: 'Delete Certification',
      delete_body: 'Are you sure you want to delete this certification?',
      deleted_message: 'Certification deleted!',
    },
    work_experiences: {
      table_title: 'Work experience',
      not_found: 'No work experience found!',
      now: 'today',
      columns: {
        position: 'Position',
        organization: 'Organization',
        country: 'Country',
        city: 'City',
        start_date: 'Duration',
      },
      delete_title: 'Delete work experience',
      delete_body: 'Are you sure you want to delete this work experience?',
      deleted_message: 'Work experience deleted!',
    },
    other_documents: {
      table_title: 'Other documents',
      not_found: 'No other documents found!',
      columns: {
        title: 'Title',
      },
      delete_title: 'Delete document',
      delete_body: 'Are you sure you want to delete this document?',
      deleted_message: 'Document deleted!',
    },
  },

  applicant_form: {
    applicant_create: {
      title: 'Complete your Applicant profile',
      subtitle: 'In order to continue you have to complete your profile as Applicant!',
    },
    step_label: 'Continue',
    step1_title: 'Personal information',
    step2_title: 'Social profiles',
    step3_title: 'Documents',
    step_final_label: 'Finish',
    step_back_label: 'Back',
    email: 'Email',
    email_rule: 'Please type the email',
    password: 'Password',
    password_rule1: 'Must contain at least 8 characters',
    password_rule2: 'Must contain at least one digit',
    password_rule3: 'Must contain at least one uppercase',
    password_rule4: 'Must contain at least one special character',
    password_hint:
      'Must contain at least 8 characters, one uppercase character, one digit and one special character',
    confirm_password: 'Password confirm',
    confirm_password_rule1: 'Please retype the password',
    confirm_password_rule2: 'Please enter the same password',
    first_name_label: 'First name',
    first_name_rule: 'Please type your first name',
    last_name_label: 'Last name',
    last_name_rule: 'Please type your last name',
    date_of_birth_label: 'Your date of birth',
    date_of_birth_hint: 'Format: YYYY-MM-DD',
    date_of_birth_rule1: 'Please type your date of birth',
    date_of_birth_rule2: 'Please type a valid date',
    date_of_birth_rule3: 'Please enter a past date',
    place_of_birth_label: 'Your place of birth',
    place_of_birth_rule: 'Please select the place of birth',
    no_results: 'No results',
    gender_label: 'Your Gender',
    gender_rule: 'Please select your gender',
    nationality_label: 'Your nationality',
    nationality_rule: 'Please select at least one nationality',
    phone_label: 'Your mobile phone',
    phone_rule1: 'Please type your mobile phone',
    phone_rule2: 'Phone must be valid',
    phone_hint: 'Example: +306911111111',
    messaging_apps_label: 'Messaging Apps (optional)',
    has_whatsapp: 'I have WhatsApp',
    has_viber: 'I have Viber',
    id_number_label: 'Your ID or Passport Number',
    id_number_rule: 'Please type your ID or Passport Number',
    linkedin_profile_label: 'Your Linkedin profile',
    linkedin_profile_hint: "Must contain 'https://www.linkedin.com'",
    linkedin_profile_rule: 'Please enter a valid linkedin profile',
    scholar_profile_label: 'Your Scholar profile',
    scholar_profile_hint: "Must contain 'https://scholar.google.com'",
    scholar_profile_rule: 'Please enter a valid Scholar profile',
    scopus_profile_label: 'Your Scopus profile',
    scopus_profile_hint: "Must contain 'https://www.scopus.com'",
    scopus_profile_rule: 'Please enter a valid Scopus profile',
    cv_label: 'Your CV',
    cv_hint: 'Max file size:5 MB',
    photo_label: 'Your Photo',
    photo_hint: 'Optional(Max file size:5 MB)',
    terms_label1: 'Do you agree with the',
    terms_label2: 'terms & conditions?',
    terms_rule: 'You must acknowledge the terms & conditions.',
    profile_updated_message: 'Profile updated successfully!',
    created_message: 'Profile created successfully!',
  },
  account_form: {
    title: 'Update account',
    input1_label: 'First name',
    input1_rule: 'Please type your first name',
    input2_label: 'Last name',
    inpu2_rule: 'Please type your last name',
    submit_btn: 'Confirm',
  },
  contact_info_form: {
    title: 'Add contact information',
    edit_title: 'Edit contact information',
    type_label: 'Type',
    type_rule: 'Please enter the type',
    country_label: 'Country',
    country_rule: 'Please enter the country',
    no_results: 'No results',
    city_label: 'City',
    city_rule: 'Please enter the city',
    address_label: 'Address',
    address_rule: 'Please type the address',
    postal_code_label: 'Postal code',
    postal_code_rule1: 'Please type the postal code',
    postal_code_rule2: 'Postal code must have maximum 10 alphanumeric',
    phone_label: 'Phone',
    phone_rule1: 'Please type the phone',
    phone_rule2: 'Phone must be valid',
    phone_hint: 'Example: +302101111111',
    submit_btn: 'Submit',
    created_message: 'Contact information saved!',
    edited_message: 'Contact information updated!',
  },
  education_degree_form: {
    degree_types: {
      high_school: 'High School Diploma',
      bsc: 'Bachelor (BSc)',
      msc: 'Master (MSc)',
      phd: 'Doctorate (PhD)',
    },
    title: 'Add education degree',
    edit_title: 'Edit education degree',
    hint: 'If you have not yet obtained your degree you can enter the estimated date of acquisition without uploading the degree file.',
    title_label: 'Title',
    title_rule: 'Please type the title',
    type_label: 'Type',
    type_rule: 'Please enter the type',
    enrollment_date_label: 'Enrollment Date',
    enrollment_date_hint: 'Format: YYYY-MM-DD',
    enrollment_date_rule1: 'Please type the enrollemnt date',
    enrollment_date_rule2: 'Please type a valid date',
    enrollment_date_rule3: 'Please enter a past date',
    graduation_date_label: 'Graduation Date',
    graduation_date_hint: 'Format: YYYY-MM-DD',
    graduation_date_rule1: 'Please type the graduation date',
    graduation_date_rule2: 'Please type a valid date',
    grade_label: 'Grade',
    grade_rule: 'Please type the grade',
    country_label: 'Country',
    country_rule: 'Please enter the country',
    no_results: 'No results',
    institution_label: 'Institution',
    institution_rule: 'Please type the institution',
    department_label: 'Department',
    department_rule: 'Please type the department',
    dissertation_title_label: 'Dissertation title',
    dissertation_title_hint: 'Optional',
    dissertation_abstract_label: 'Dissertation Abstract',
    dissertation_abstract_hint: 'Optional',
    degree_file_label: 'Your degree file',
    degree_file_hint: 'Optional (Max file size:5 MB)',
    dissertation_file_label: 'Your Dissertation file',
    dissertation_file_hint: 'Optional',
    submit_btn: 'Submit',
    created_message: 'Education degree saved!',
    edited_message: 'Education degree updated!',
    institution_label_hs: 'High School Name',
    department_label_hs: 'Direction / Specialization',
    department_hint_hs: 'e.g. Science, Humanities (Or type "General")',
    department_rule_hs: 'Please enter your direction',
  },
  language_cert_form: {
    title: 'Add language certification',
    edit_title: 'Edit language certification',
    title_label: 'Title',
    title_rule: 'Please type the title',
    language_label: 'Language',
    language_rule: 'Please enter the language',
    no_results: 'No results',
    score_label: 'Score',
    score_rule: 'Please enter the score',
    acquisition_date_label: 'Acquisition date',
    acquisition_date_hint: 'Format: YYYY-MM-DD',
    acquisition_date_rule1: 'Please type the acquisition date',
    acquisition_date_rule2: 'Please type a valid date',
    acquisition_date_rule3: 'Please enter a past date',
    degree_file_label: 'Your Degree',
    degree_file_hint: 'Max file size:5 MB',
    submit_btn: 'Submit',
    created_message: 'Language certification saved!',
    edited_message: 'Language certification updated!',
  },
  other_document_form: {
    title: 'Add other document',
    edit_title: 'Edit other document',
    title_label: 'Title',
    title_rule: 'Please type the title',
    document_file_label: 'Your Document',
    document_file_hint: 'Max file size:5 MB',
    submit_btn: 'Submit',
    created_message: 'Other document saved!',
    edited_message: 'Other document updated!',
  },
  work_experience_form: {
    title: 'Add work experience',
    edit_title: 'Edit work experience',
    position_label: 'Position',
    position_rule: 'Please type the position',
    organization_label: 'Organization',
    organization_rule: 'Please enter the organization',
    job_description_label: 'Job Description',
    job_description_rule: 'Please enter the job description',
    country_label: 'Country',
    country_rule: 'Please enter the country',
    no_results: 'No results',
    city_label: 'City',
    city_rule: 'Please enter the city',
    start_date_label: 'Start date',
    start_date_hint: 'Format: YYYY-MM-DD',
    start_date_rule1: 'Please type the start date',
    start_date_rule2: 'Please type a valid date',
    start_date_rule3: 'Please enter a past date',
    is_working_label: 'Still working?',
    end_date_label: 'End date',
    end_date_hint: 'Format: YYYY-MM-DD',
    end_date_rule1: 'Please type the end date',
    end_date_rule2: 'Please type a valid date',
    end_date_rule3: 'Please enter a past date',
    work_experience_file_label: 'Work Experience file',
    work_experience_file_hint: 'Optional (Max file size:5 MB)',
    submit_btn: 'Submit',
    created_message: 'Work experience saved!',
    edited_message: 'Work experience updated!',
  },
  certification_form: {
    title: 'Add certification',
    edit_title: 'Edit certification',
    name_label: 'Name',
    name_rule: 'Please type the name',
    issued_by_label: 'Issued By',
    issued_by_rule: 'Please type the organization',
    issue_date_label: 'Issue date',
    issue_date_hint: 'Format: YYYY-MM-DD',
    issue_date_rule1: 'Please type the issue date',
    issue_date_rule2: 'Please type a valid date',
    issue_date_rule3: 'Please enter a past date',
    is_expiring_label: 'Is expiring?',
    end_date_label: 'End date',
    end_date_hint: 'Format: YYYY-MM-DD',
    end_date_rule1: 'Please type the end date',
    end_date_rule2: 'Please type a valid date',
    end_date_rule3: 'Please enter a future date',
    credential_id_label: 'Credential id',
    credential_id_hint: 'Optional',
    credential_url_label: 'Credential URL',
    credential_url_hint: 'Optional',
    certification_file_label: 'Your Certification File',
    certification_file_hint: 'Optional(Max file size:5 MB)',
    submit_btn: 'Submit',
    created_message: 'Certification saved!',
    edited_message: 'Certification updated!',
  },
  reference_form: {
    header: 'Upload Reference Letter',
    applicant_info: 'Applicant Information',
    contact_student: 'Contact the student',
    request_message:
      'You have been requested to upload a reference letter for the application to the program:',
    upload_btn: 'Upload Letter',
    reject_text: 'You do not wish to provide a letter?',
    reject_btn: 'Reject Request',
    success_upload: 'The reference letter was uploaded successfully!',
    success_reject: 'The request has been rejected.',
    view_existing: 'View existing file',
    file_label: 'Select PDF file',
    not_found: 'Reference not found or link expired.',
    already_uploaded_title: 'Reference Received',
    already_uploaded_desc:
      'You have already uploaded a reference letter for this applicant. You can view the document or upload a new one to replace it.',
    rejected_title: 'Request Declined',
    rejected_message:
      'You have declined this reference request. No further action is required from your side, and the applicant has been notified.',
  },
  leads: {
    title: 'Expression of Interest',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    country: 'Country of Origin',
    phone: 'Phone',
    notes: 'Notes',
    submit: 'Submit',
    cancel: 'Cancel',
    required: 'Field is required',
    success: 'Success! We will contact you.',
    error: 'Submission error.',
  },
  agent_select_field: {
    label: 'Select Agent',
    no_results: 'No agents found',
  },
  agent: {
    applicants: {
      select_to_continue: 'Select applicant to continue',
      list_title: 'Applicants List',
      search_placeholder: 'Search by name or email...',
      new_applicant_btn: 'New Applicant',
      select_to_manage: 'Select an applicant from the list to manage',
      created_success: 'Applicant created successfully',
      no_results: 'No applicants found',
    },
    new_app: {
      modal_title: 'Start New Application',
      select_programme: 'Search Programme',
      select_call: 'Select Call Period',
      no_active_calls: 'No active call periods found.',
      start_application: 'Create Application',
      cancel: 'Cancel',
      status_open: 'Open',
    },
  },

  agents: {
    title: 'Agent Management',
    search: 'Search',
    new_agent: 'New Agent',
    edit_agent: 'Edit Agent',
    delete_confirm_title: 'Delete',
    delete_confirm_msg: 'Are you sure you want to delete {email}?',
    fields: {
      email: 'Email',
      first_name: 'First Name',
      last_name: 'Last Name',
      role: 'Role',
      agency_name: 'Agency Name',
      password: 'Password',
      actions: 'Actions',
    },
    form: {
      email_rule: 'Please type the email',
      password_rule1: 'Must contain at least 8 characters',
      password_rule2: 'Must contain at least one digit',
      password_rule3: 'Must contain at least one uppercase',
      password_rule4: 'Must contain at least one special character',
      password_hint:
        'Must contain at least 8 characters, one uppercase character, one digit and one special character',
      confirm_password: 'Password confirm',
      confirm_password_rule1: 'Please retype the password',
      confirm_password_rule2: 'Please enter the same password',
      first_name_rule: 'Please type your first name',
      last_name_rule: 'Please type your last name',
    },
    messages: {
      created: 'Agent created successfully',
      updated: 'Agent updated successfully',
      deleted: 'Agent deleted successfully',
    },
    dialog: {
      cancel: 'Cancel',
      submit: 'Submit',
    },
  },
  how_to: {
    title: 'Follow this simple guide to apply to your favourite course successfully',
    par1: "Many have tried to navigate the institution application process for studying abroad\
      but don't know where\
      to start. The application process can be difficult, but it doesn't have to be! Whether you need help\
      with your institution's application or with your profile, {'@'}SiG will guide you through the steps of\
      applying\
      for your favourite programs in Greece. These are the steps you need to apply for any Greek institution.\
    ",
    title2: 'How to apply ',
    story1_title: 'Choose where and what you’d like to study',
    story1_par1: 'Search for programs and institutions',
    story1_par2: 'Check admission criteria, fees and deadlines.',
    story1_par3: 'Compare different programs',
    story2_title: 'Login and complete your profile',
    story2_par1: 'Create your free account',
    story2_par2: 'Complete your profile',
    story2_par3: 'Fill in all the required information',
    story3_title: 'Fill in your contact details and educational history',
    story3_par1: 'Add your contact details',
    story3_par2: 'Fill in your educational history',
    story3_par3: 'Assemble all required documents',
    story4_title: 'Submit all your documents and complete your profile',
    story4_par1: 'Upload all the requested documents (only once)',
    story4_par2: 'Check if all documents are uploaded properly',
    story4_par3: 'Verify your profile summary before submission',
    story5_title: 'Wait for a response from the institution',
    story5_par1: "Get updates from {'@'}SiG about the admissions process",
    story5_par2: 'Check your dashboard from time to time',
    story5_par3: 'Stay updated on the process',
  },
  privacy: {
    title: 'AtSiG Privacy Policy',
    desc: {
      p1: 'We are pleased that you are visiting our website. Data protection and data security when using our website are very important to us. We want to take this opportunity to inform you about the type of personal data we collect in relation to your visit to our site and for what purpose this data are used.',
      p2: 'Since legislative changes or changes in our internal company processes may require an adjustment of this privacy policy, we would like to ask you to review this privacy statement on a regular basis.',
    },
    sections: {
      1: {
        title: '1. GENERAL',
        p1: "{'@'}SiG is a new platform that allows users to submit, with ease and success, their applications to study in study programs of Greek Public Universities. In order for the user to use the platform, they first need to create an account. The process of creating the account involves entering some personal data, in order to be able to successfully submit their applications. This is the usual standard data entry procedure when applying for a study program (e.g. Bachelor’s, Master’s etc.). ",
        p2: 'Thus, the main purpose of submitting your personal data when creating the account is to identify the University that will receive your application.',
      },
      2: {
        title: '2. PERSONAL DATA',
        p1: 'When setting up your account, we collect the following information:',
        list: [
          'Full name',
          'ID/Passport Number',
          'Date of Birth',
          'Place of Birth',
          'Nationality',
          'Email Address',
          'Gender',
          'Social media account name and email (in case you create the account via social login)',
        ],
        p2: 'Also, the user’s IP is collected for security reasons, but without association with behavior within the system.',
        p3: 'Moreover, data is collected by other platforms used in the processing of the data, which we will refer to below (sections 7 and 8). These platforms include Google Analytics or Google Tag Manager. Section 8 is dedicated to describe Google Analytics shortly.',
        p4: 'For more info, please check these platforms’ respective privacy policies.',
      },
      3: {
        title: '3. PURPOSES OF YOUR DATA COLLECTION AND PROCESSING',
        p1: 'The collection and processing of your data is aimed at completing the service of the platform, which is to enable the application to study programs.',
        p2: 'In connection with the use of this site, we process your personal data for the following purposes:',
        list: [
          'Provision of services via contact forms',
          'Conducting personal and anonymous analyses',
          'Statistical analyses',
          'To prevent misuse',
        ],
        p3: 'Additional purposes are statistical analyses, which will help us get a better picture of student preferences and, of course, none of these analyzes will show any identifying information about you.',
      },
      4: {
        title: '4. SECURITY OF YOUR DATA',
        p1: 'We will take the necessary technical and organizational precautions to prevent the loss, misuse or alteration of your personal data.',
        p2: 'We will store all personal data you provide on our secure (password and firewall protected) servers.',
        p3: 'You are responsible for keeping the password you use confidential, we will not ask you for your password (except when you log in to our website).',
      },
      5: {
        title: '5. MODIFICATIONS',
        p1:
          'We may update our policy from time to time by posting a new version on our website. You can check the page occasionally to make sure you understand any change to our policy. We may notify you of changes to our policy by email or through a private messaging system on our website.\n' +
          '\n' +
          'There will definitely be an update if something changes about the collection (e.g. if we need to collect more data) or the purposes of the collection and processing (e.g. if a new purpose is added or an existing one is changed).',
      },
      6: {
        title: '6. PRESERVATION OF PERSONAL DATA',
        p1: 'This section sets out our personal data retention process and policy, designed to ensure compliance with our legal obligations regarding the retention and deletion of personal data.',
        p2: 'Personal data that we process for any purpose will not be kept for longer than is necessary for that purpose.',
        p3: 'Of course, you can deactivate your account whenever you choose and your data is deleted.',
      },
      7: {
        title: '7. COOKIES',
        p1: 'This platform uses cookies:',
        list: [
          "a) {'@'}SiG cookies necessary for the functionality of the website",
          'b) Cookies of Google Analytics or Google Tag Manager platforms with user IP anonymization. Cookies from Facebook pixel.',
        ],
        p2: 'For more information, please check our Cookies Policy',
      },
      8: {
        title: '8. GOOGLE ANALYTICS',
        p1: 'This website uses Google Analytics, a web analytics service provided by Google Inc. (hereinafter referred to as “Google”). Google Analytics uses cookies, which are stored on your computer. This allows an analysis of your use of the website. The information that the cookie generates about your use of this website (including your IP-address) is usually transmitted to and stored on a Google-operated server in the USA. This website uses Google Analytics with the anonymize_ip paramter set to true for IP anonymization. Your IP address will be previously shortened within Member States of the European Union or in other States party to the Agreement on the European Economic Area; which prevents it being directly linked to any particular individual. Only in exceptional cases will the full IP address be transmitted to a Google server in the USA and shortened there. Google will use this information on our behalf to evaluate your use of the website, to compile reports on the website activities for us and to provide additional services connected with the use of the website and the internet. You can prevent the installation of cookies by setting your browser software accordingly. Please note, however, that in this case you may not be able to use the full functionality of this website. In addition, you can prevent the processing of the data generated by the cookie (including your IP address) and your use of the website, as well as the processing of this data by Google, by downloading and installing the following browser plug-in',
      },
      9: {
        title: '9. DISCLOSURE OF YOUR INFORMATION',
        p1: 'As a rule, we do not disclose your personally identifiable information to third parties with the exception of the cases presented here. Deviating hereof, however, we may be required in some cases to disclose your personal information to competent and official law enforcement agencies and only for reasons of public safety. This is for example the case if there is suspicion of a crime or misuse of our website.',
      },
      10: {
        title: '10. THIRD PARTIES',
        p1: 'The only third parties with access to your personal data are the Institutions that have an account on the platform and manage programs through it and only on the condition that you have applied for one of these programs. The access to your personal data is obtained only through the application and is not available otherwise.',
        p2: "After completing the application, your personal data will have been stored on the University's website, which is outside the {'@'}SiG platform. Even if we delete, at your request, your data may continue to be stored by the respective Institution's website, for which we bear no responsibility and, in case you wish to delete or any other action regarding the data to a website other than ours, please contact the administrators of this external website.",
      },
      11: {
        title: '11. RIGHTS TO YOUR PERSONAL DATA',
        p1: 'We inform you that at any time you retain the following rights:',
        list: [
          'You can request the deletion or correction of you data',
          'You can access the data a business holds about you',
          'You can request the transmission of your data to third parties',
          'You must consent to the use of your data',
        ],
      },
      12: {
        title: '12. CONTACT DETAILS',
        p1: "For questions and/or comments about our Privacy Policy and this statement, please contact us by creating a ticket on our Helpdesk. Please choose {'@'}SiG --> Terms of Use as a helptopic.",
      },
    },
    footer: 'Last updated on 06/04/2023',
  },
  terms: {
    title: 'AtSiG Account Terms Consent',

    p1: 'To complete your account, you will need to agree to the terms below.',
    p2: 'We attach great importance and care to the protection of your personal data, as well as to your best service! Thus, we kindly ask you to carefully read the following.',
    section1: {
      title: '1. PERSONAL DATA',
      p1: 'By agreeing to the terms below, you accept the collection and processing of your personal data as follows:',
      list: [
        'By applying to the program of the University of your choice, you agree to the disclosure of your profile data to the respective Institution for identification purposes.',
        'You agree to the use of your personal data for anonymous statistical surveys. Anonymous means that there will be no information to connect your personal data to the respective surveys.',
        'You agree that under no circumstances will your personal data be disclosed, except to a competent and official Law Enforcement Authority and only for reasons related to Public Safety, such as a suspicion for a crime, misuse of our website etc.',
        'You agree that, after deleting your personal data, we bear no responsibility for the collection and processing of your data by external pages, on which they have been registered with your consent (e.g. websites of Universities, to which you have applied)',
        'With regard to your account password, you agree that it is solely your responsibility to keep it confidential and we are not responsible for access to your profile by a third party who becomes aware of the password by you.',
      ],
      p2: "If you do not accept these terms, then you cannot complete the creation of an account on {'@'}SiG.",
      p3: 'For more information about the processing and your rights over your data, please check our Privacy Policy ',
    },
    footer: 'Last updated on 06/04/2023',
  },
  program_matcher: {
    fab_label: 'AI Program Finder',
    hero_btn: 'Not sure? Get matched',
    title: 'Find your matching program',
    step_counter: 'Step {current} of {total}',
    steps: {
      type: {
        question: 'What are you looking for?',
        options: {
          master: "Master's (MSc/MA/MBA)",
          bachelor: "Bachelor's (BSc/BA)",
          any: 'Any level',
        },
      },
      topics: {
        question: 'Which fields interest you?',
        hint: '(pick all that apply)',
        options: {
          technology: 'Technology',
          science: 'Science and Engineering',
          health: 'Health',
          economics: 'Economics Management',
          humanities: 'Humanities',
          environmental: 'Environmental Sciences',
          social: 'Social Sciences',
          law: 'Law Sciences',
          agriculture: 'Agriculture',
          politics: 'Politics',
          arts: 'Arts',
          education: 'Education Sciences',
          tourism: 'Tourism Studies',
          sports: 'Sports',
        },
      },
      mode: {
        question: 'How do you want to study?',
        options: {
          in_person: 'In person',
          online: 'Online / remote',
          any: 'No preference',
        },
      },
      language: {
        question: 'What language of instruction do you prefer?',
        options: {
          english: 'English',
          greek: 'Greek',
          any: 'No preference',
        },
      },
      tuition: {
        question: "What's your tuition budget?",
        scholarship: 'Scholarship available',
        open_applications: 'Open for applications now',
        options: {
          free: 'Free only',
          low: 'Up to €3,000',
          mid: 'Up to €7,000',
          any: 'Any budget',
        },
      },
      free_text: {
        question: 'Anything else we should know?',
        hint: '(optional)',
        boost: 'Adding context helps AthenAI find significantly more relevant matches for you',
        placeholder: 'e.g. I have a background in biology and want to focus on marine conservation',
        tip: 'Mention your goals, background, or what you want from your studies',
        suggestions: {
          career: 'I want to switch careers from…',
          background: 'My academic background is in…',
          research: 'Looking for a research-focused programme',
          location: 'I prefer to study in…',
        },
      },
    },
    nav: {
      back: 'Back',
      next: 'Next',
      find_matches: 'Find matches',
    },
    results: {
      searching: 'Searching programs…',
      matched_singular: '1 program matched',
      matched_plural: '{count} programs matched',
      start_over: 'Start over',
      no_matches_title: 'No matches found',
      no_matches_desc: 'Try relaxing your filters or change your preferences.',
      view_program: 'View program',
      not_dream_match: 'Not your dream match?',
      compare_btn: 'Compare',
      selected: '✓ Selected',
      broader_suggestions: 'Broader suggestions',
      view: 'View',
      compare_selected: '2 programmes selected',
      badges: {
        free: 'Free',
        open: 'Open',
        master: 'Master',
        bachelor: 'Bachelor',
        phd: 'PhD',
        in_person: 'In Person',
        remotely: 'Online',
      },
    },
    resume: {
      title: 'Welcome back',
      subtitle: 'Your last search',
      matched_singular: '1 programme matched',
      matched_plural: '{count} programmes matched',
      new_search: 'New search',
      see_results: 'See your results',
    },
    refine: {
      title: 'Tell AthenAI more',
      career_question: 'What are your career goals after graduation?',
      career_hint: '— e.g. "work in AI research", "start a business"',
      career_placeholder: 'Tell AthenAI what you want to achieve…',
      background_question: 'What is your academic background?',
      background_hint: '— e.g. "BSc in Computer Science", "background in economics"',
      background_placeholder: 'Describe your studies or background…',
      topics_question: 'Any specific topics, technologies or research areas?',
      topics_hint: '— be as specific as you like',
      topics_placeholder: 'e.g. machine learning and climate modelling…',
      back: 'Back to results',
      submit: 'Find better matches',
      error: 'Something went wrong. Please try again.',
    },
    compare: {
      title: 'AthenAI · Comparison',
      comparing: 'AthenAI is comparing…',
      unavailable: 'Comparison unavailable',
      close: 'Close',
      focus: 'Focus',
      best_for: 'Best for',
    },
    match_labels: {
      excellent: '★ Excellent match',
      great: 'Great match',
      good: 'Good match',
      fair: 'Fair match',
      possible: 'Possible match',
    },
  },
  about: {
    title: 'About AtSiG',

    subtitle:
      'Welcome to AtSiG, the platform by Study in Greece that aims to make applying to Greek universities as simple and easy as possible. Create your profile, upload your documents and start applying!',
    btn_label: 'Learn More About SiG',
    offer_title: "What {'@'}SiG has to offer",
    applicant_section: {
      title: 'For Applicants:',
      list: [
        'Display of all Master’s programs available across all Greek Universities.',
        "See which study programs have open calls for application at any time and check which programs you can apply for through {'@'}SiG.",
        'Even when applications are closed, mark programs as favourite and receive notifications when open calls are posted!',
        'Profile creation for applicants is simple and supports many different features, allowing deep customization and personalization for applicant profiles.',
        'With all the documents and certificates you upload to your profile, you can apply to as many programs as you like just with one click!',
      ],
    },
    university_section: {
      title: 'For Universities:',
      list: [
        'With a Secretary account, publish and manage detailed program descriptions, just by filling out a simple form.',
        'Set open calls for each individual program easily.',
        'Receive applications with all the necessary documents that you have listed for your programs.',
        'Evaluate your applications in a user-friendly interface and directly request feedback from your applicants.',
        'Finalize the applications’ status with unmatched efficiency and welcome your new students!',
      ],
    },
    our_team_section: {
      title: 'Our Team, Our Vision',
      par: 'Our team consists of experienced software developers and professionals in the field of higher education. Our primary goal is to help students discover study programs tailored to their wants and needs, by making the process of applying as easy and as quick as possible. At the same time, we aim to provide universities that receive applications a simple, but comprehensive tool to manage and evaluate these applications.',
    },
    contact: {
      title: 'Contact us',
      par: "If you have any questions or feedback, please don't hesitate to reach out to us at the SiG Helpdesk or on the SiG social media.",
    },
  },
  public_survey: {
    header: 'Foreign students survey',
    year: 'Academic year',
    intro: 'Enter the foreign students of the programme by country of origin and age group.',
    invalid_link: 'This link is invalid or has expired.',
    declared_title: 'You have declared that there are no foreign students',
    declared_message: 'If you add data, the declaration is removed automatically.',
    existing_title: 'Submitted data',
    add_title: 'Add data',
    country: 'Country of origin',
    country_rule: 'Please select a country',
    no_results: 'No results',
    age_group: 'Age group',
    age_group_rule: 'Please select an age group',
    age_groups: { up_to_25: 'Up to 25', over_25: 'Over 25' },
    male: 'Male',
    female: 'Female',
    other: 'Other',
    number_rule: 'Enter a non-negative whole number',
    zero_total: 'Enter at least one student',
    add_btn: 'Add',
    row_saved: 'Data saved',
    delete: 'Delete',
    delete_confirm: 'Delete the entry {country} ({age_group})?',
    row_deleted: 'Entry deleted',
    no_students_text: 'No foreign students?',
    no_students_btn: 'No foreign students',
    no_students_disabled: 'Delete the submitted data first',
    no_students_confirm: 'This declares that the programme has no foreign students for this year.',
    no_students_saved: 'Declaration saved',
    load_error: 'The form could not be loaded',
  },
}
